"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_react_lite_1 = require("mobx-react-lite");
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("../../../../context");
const styling_1 = require("../../../../styling");
const utils_1 = require("../../../../styling/utils");
const Select_1 = tslib_1.__importDefault(require("../../../../ui-lib/Inputs/Select"));
const ErrorBoundary_1 = require("../../../ErrorBoundary");
var AspectRatios;
(function (AspectRatios) {
    AspectRatios[AspectRatios["3:2"] = 1.5] = "3:2";
    AspectRatios[AspectRatios["4:3"] = 1.3333333333333333] = "4:3";
    AspectRatios[AspectRatios["16:9"] = 1.7777777777777777] = "16:9";
    AspectRatios[AspectRatios["8:5"] = 1.6] = "8:5";
})(AspectRatios || (AspectRatios = {}));
const DELTA = 0.001;
function aspectRationToString(val) {
    if (val == null) {
        return null;
    }
    const ar = Array.isArray(val) ? val[0] : val;
    for (const key of Object.keys(AspectRatios)) {
        const diff = Math.abs(AspectRatios[key] - ar);
        if (diff < DELTA) {
            return key;
        }
    }
    return null;
}
/**
 * @todo: Possibly refactor Select Components
 *
 */
const ModularAspectRatioSelect = (0, mobx_react_lite_1.observer)(({ classes = {}, ...props }) => {
    var _a;
    /**
     * Component Name (for error msg)
     */
    const componentName = "<AspectRatioSelect/>";
    const availableAspectRatios = Object.keys(AspectRatios);
    const mergedClasses = (0, styling_1.useStyles)({ source: classes, target: {} }, "select");
    const mergedStyles = (0, utils_1.mergeStylesObjects)(classes, {});
    /**
     * Access Context & destructure API state
     */
    const ctx = (0, react_1.useContext)(context_1.EncoderUiContext);
    /**
     * Throw error (and trigger ErrorBoundary) if store is undefined.
     * */
    (0, ErrorBoundary_1.useUndefinedStoreError)((ctx === null || ctx === void 0 ? void 0 : ctx.mediaStreamController) != null, componentName);
    /**
     * On input change handler to (1) update API and (2) update component
     * <select> value with user selected audio device.
     */
    const selectAspectRatio = (ev) => {
        const ar = AspectRatios[ev.target.value];
        if (ar == null) {
            throw new Error(`${componentName}: Invalid aspect ratio: ${ev.target.value}`);
        }
        ctx.mediaStreamController.aspectRatio = ar;
    };
    /**
     * Wrap onChange function in global Error handler (to trigger ErrorBoundary).
     * */
    const handleInputChange = (0, ErrorBoundary_1.useUIEventError)(selectAspectRatio, componentName);
    return (react_1.default.createElement(Select_1.default, { classes: mergedStyles, label: `Aspect Ratio: ${aspectRationToString(ctx.mediaStreamController.aspectRatio)}`, onChange: handleInputChange, value: (_a = aspectRationToString(ctx.mediaStreamController.aspectRatio)) !== null && _a !== void 0 ? _a : undefined },
        react_1.default.createElement("option", { disabled: true, value: "" }, "Select an aspect ratio"),
        availableAspectRatios.map((ratio) => (react_1.default.createElement("option", { key: ratio, value: ratio, className: mergedClasses.options }, ratio)))));
});
// eslint-disable-next-line react/function-component-definition
const AspectRatioSelectWithErrorBoundary = ({ classes = {}, ...props }) => {
    const mergedClasses = (0, styling_1.useStyles)({ source: classes, target: {} }, "select");
    const mergedStyles = (0, utils_1.mergeStylesObjects)(classes, {});
    return (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { render: () => {
            var _a;
            return (react_1.default.createElement(Select_1.default, { ...props, value: "", classes: mergedStyles, disabled: true },
                react_1.default.createElement("option", { value: "", className: mergedClasses === null || mergedClasses === void 0 ? void 0 : mergedClasses.options }, (_a = props.fallbackText) !== null && _a !== void 0 ? _a : "Aspect Ratio Unavailable")));
        } },
        react_1.default.createElement(ModularAspectRatioSelect, { classes: classes, ...props })));
};
exports.default = AspectRatioSelectWithErrorBoundary;
//# sourceMappingURL=AspectRatioSelect.js.map